(function(){
  'use strict';

  function isMobile(){
    return !!(window.matchMedia && window.matchMedia('(max-width: 767px)').matches);
  }

  function addStyles(){
    if (document.getElementById('erectus-mobile-searchbar-styles')) return;
    var style = document.createElement('style');
    style.id = 'erectus-mobile-searchbar-styles';
    style.textContent = [
      '@media (max-width:767px){',
      '#lheader .header-control>li.header_search{display:none!important;}',
      '#lheader .erectus-mobile-direct-search{display:block!important;width:100%!important;padding:0 12px 10px!important;margin:0!important;}',
      '#lheader .erectus-mobile-direct-search form{display:flex!important;align-items:center!important;width:100%!important;height:46px!important;margin:0!important;border:1px solid #d8d8d8!important;border-radius:24px!important;background:#f6f6f6!important;overflow:hidden!important;box-shadow:none!important;}',
      '#lheader .erectus-mobile-direct-search input[type="search"]{display:block!important;flex:1 1 auto!important;min-width:0!important;width:auto!important;height:44px!important;margin:0!important;padding:0 8px 0 16px!important;border:0!important;border-radius:0!important;background:transparent!important;color:#111!important;font-size:15px!important;line-height:44px!important;outline:0!important;box-shadow:none!important;-webkit-appearance:none!important;appearance:none!important;}',
      '#lheader .erectus-mobile-direct-search input[type="search"]::placeholder{color:#777!important;opacity:1!important;}',
      '#lheader .erectus-mobile-direct-search input[type="search"]::-webkit-search-cancel-button{margin-right:2px!important;}',
      '#lheader .erectus-mobile-direct-search button{display:flex!important;align-items:center!important;justify-content:center!important;flex:0 0 48px!important;width:48px!important;height:44px!important;margin:0!important;padding:0!important;border:0!important;background:transparent!important;color:#111!important;box-shadow:none!important;}',
      '#lheader .erectus-mobile-direct-search button .icon_search{font-size:22px!important;line-height:1!important;}',
      '#lheader .header-top .container{padding-bottom:0!important;}',
      '}',
      '@media (min-width:768px){#lheader .erectus-mobile-direct-search{display:none!important;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function createSearch(){
    if (!isMobile()) return;
    var header = document.querySelector('#lheader .header-top');
    var container = header && header.querySelector('.container');
    if (!container || container.querySelector('.erectus-mobile-direct-search')) return;

    var wrap = document.createElement('div');
    wrap.className = 'erectus-mobile-direct-search';

    var form = document.createElement('form');
    form.action = '/search';
    form.method = 'get';
    form.setAttribute('role', 'search');
    form.setAttribute('aria-label', 'Buscar productos');

    var type = document.createElement('input');
    type.type = 'hidden';
    type.name = 'type';
    type.value = 'product';

    var input = document.createElement('input');
    input.type = 'search';
    input.name = 'q';
    input.placeholder = '¿Qué estás buscando?';
    input.setAttribute('aria-label', 'Buscar productos');
    input.setAttribute('enterkeyhint', 'search');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('spellcheck', 'false');

    try {
      var params = new URLSearchParams(window.location.search || '');
      if (params.get('q')) input.value = params.get('q');
    } catch(e) {}

    var button = document.createElement('button');
    button.type = 'submit';
    button.setAttribute('aria-label', 'Buscar');
    button.innerHTML = '<i class="icon_search" aria-hidden="true"></i>';

    form.appendChild(type);
    form.appendChild(input);
    form.appendChild(button);
    wrap.appendChild(form);
    container.appendChild(wrap);
  }

  function run(){
    addStyles();
    createSearch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
})();
